import { render, staticRenderFns } from "./annualEducationPlanAppr.vue?vue&type=template&id=69bc5416"
import script from "./annualEducationPlanAppr.vue?vue&type=script&lang=js"
export * from "./annualEducationPlanAppr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69bc5416')) {
      api.createRecord('69bc5416', component.options)
    } else {
      api.reload('69bc5416', component.options)
    }
    module.hot.accept("./annualEducationPlanAppr.vue?vue&type=template&id=69bc5416", function () {
      api.rerender('69bc5416', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/appr/sop/edu/annualEducationPlanAppr.vue"
export default component.exports